import axios from "axios";
import { API_URL, IS_AUTH_REQUIRED } from "./config";
import storage from "./utils/storage";

if (API_URL) {
  axios.defaults.baseURL = API_URL;
}

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      IS_AUTH_REQUIRED &&
      error?.response &&
      error.response.status === 401
    ) {
      storage.clearAuthStatus();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;

